// Copyright (c) 2026 Yunus YILDIZ — SPDX-License-Identifier: BUSL-1.1

export const ROUTES = {
  // Auth
  LOGIN: '/login',
  REGISTER: '/register',
  /** OAuth return + session poll (after Microsoft redirect) */
  MICROSOFT_AUTH_COMPLETE: '/auth/microsoft/complete',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  ACCEPT_INVITE: '/invite/:token',

  // App
  DASHBOARD: '/',
  DOCUMENTS: '/documents',
  DOCUMENT_DETAIL: '/documents/:id',
  API_KEYS: '/api-keys',
  WEBHOOKS: '/webhooks',
  WEBHOOK_DETAIL: '/webhooks/:id',
  SCHEMA_REGISTRY: '/schema-registry',
  AUDIT_LOG: '/audit-log',
  BILLING: '/billing',
  /** In-app notification inbox (not preferences — those are under Settings → Notifications). */
  NOTIFICATIONS: '/notifications',

  // Settings
  SETTINGS: '/settings',
  SETTINGS_PROFILE: '/settings/profile',
  SETTINGS_ORGANIZATION: '/settings/organization',
  SETTINGS_TEAM: '/settings/team',
  SETTINGS_SECURITY: '/settings/security',
  SETTINGS_NOTIFICATIONS: '/settings/notifications',
  SETTINGS_COMMUNICATIONS: '/settings/communications',

  // Errors
  NOT_FOUND: '/404',
} as const

export type RouteKey = keyof typeof ROUTES

export function buildRoute(route: string, params: Record<string, string>): string {
  return Object.entries(params).reduce(
    (path, [key, value]) => path.replace(`:${key}`, value),
    route
  )
}
